<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="section"><div class="section level3" id="about-the-author">
<p style="font-size: 20pt; font-family: calibri; text-align: center; padding-top:200px;">OF TOWNS AND COUNTRIES</p>
<p style="font-size: 20pt; font-family: calibri; text-align: center;"><em>- journey of an architect -</em></p>
<p style="font-size: 20pt; font-family: calibri; padding-top: 120px; text-align: center;">Dirk Bolt</p>
<p style="padding-top: 250px; text-align: center;"><img alt="" src="media/log.png" style="width:300px;height:50px"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?17db043e